import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  DISCORD_URL,
  EMAIL_OPENFORGE,
  OPENFORGE_WEBSITE_URL,
} from '@app/config';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-partners-openforge-cta-section',
  imports: [RouterLink, TuiButton],
  templateUrl: './partners-openforge-cta-section.component.html',
  styleUrl: './partners-openforge-cta-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersOpenforgeCtaSectionComponent {
  protected readonly openForgeWebsite = OPENFORGE_WEBSITE_URL;
  protected readonly emailOpenforge = EMAIL_OPENFORGE;
  protected readonly discordUrl = DISCORD_URL;
}
